var thisData = {}
var terms = [];
var page = 1;

/**
 * Set active parameters
 *
 * @returns array
 */
function setParameters(data)
{
    var forParams = {};
    if( terms ) {
        forParams.cat = data.terms;
    }

    if( page !== 1 ) {
        forParams.p = data.page;
    }

    var params = $.param(forParams);
    return params;
}

/**
 * Get active terms
 *
 * @return array
 */
function getActiveTerm()
{
    $('.filter-item.active').each( function() {
        terms =  $(this).data('term');
    });

    return terms;
}

/**
 * The ajax function that load posts
 */
function ajax_load_posts( thisData, emptyContainer )
{
    var params = setParameters(thisData);
    window.history.pushState("", '?', params);

    $.ajax({
        url: window.ajaxvars.ajax_url,
        type: 'post',
        data: thisData,
        beforeSend: () => {
            if( emptyContainer ) {
                $('.post-container').empty();
            }
            $('.post-container').append('<div class="post-container__loader"></div>');
            $('.filter-item').prop('disabled', true).addClass('disabled');
        },
        success: (data) => {
            $('.post-container .post-container__loader').remove();
            $('.post-container').append(data);
            $('.filter-item').prop('disabled', false).removeClass('disabled');

            $('.project-item .btn').each( function() {
                $(this).prepend('<div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>');
            });
            $('.post-item .btn').each( function() {
                $(this).prepend('<div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>');
            });
        },
    });
}

/**
 * Get Data according to post type
 */
function getData(terms)
{
    // terms = getActiveTerms();
    thisData = {
        action: 'blackdesk_load_posts',
        page: page,
        terms: terms,
        post_type: $('.post-container').data('post-type'),
        taxonomy: $('.post-container').data('taxonomy'),
    };
    return thisData;
}

/**
 * Pagination click handler
 *
 * @param event
 * @param int nextpage
 */
function pagination(event, nextpage)
{
    event.preventDefault();

    page = nextpage;
    console.log(page);
    terms = getActiveTerm();

    thisData = getData(terms);
    console.log(thisData);
    ajax_load_posts(thisData, true);
}

/**
 * Handle filter click
 */
$(document).on('click', '.filter-item', function(event) {
    event.preventDefault();
    $('.filter-item').not($(this)).each( function() {
        $(this).removeClass('active');
    });
    $(this).toggleClass('active');

    page = 1;
    thisData = getData($(this).data('term'));
    ajax_load_posts(thisData, true);
});

$(document).on('click', '.page-numbers', function(event) {
    pagination(event, $(this).html());
})

$(document).on('click', '.archive__pagination__link', function(event) {
    pagination(event, $(this).data('page'));
})
